import axios from "axios"

import { apiDomain } from "../../store/constants"

const CForm = {
    getMasterFormC (id) {
        return axios({
            url: apiDomain + `api/form-c/create?round_id=` + id,
            method: 'GET'
        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return e.response
        })
    },

    storeFormC (data) {
        return axios({
            url: apiDomain + `api/form-c`,
            method: 'POST',
            data
        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return e.response
        })
    },

    updateFormC (data) {
        return axios({
            url: apiDomain + `api/form-c/` + data.id,
            method: 'PUT',
            data: data.payload
        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return e.response
        })
    },

    updateFormCStatus (data) {
        return axios({
            url: apiDomain + `api/form-c/inception-status/` + data.id,
            method: 'PUT',
            data: data.payload
        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return e.response
        })
    },

    getFormCList (params) {
        return axios({
            url: apiDomain + `api/form-c`,
            method: 'GET',
            params
        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return e.response
        })
    },

    getEditMasterFormC (id) {
        return axios({
            url: apiDomain + `api/form-c/` + id + '/edit',
            method: 'GET',
        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return e.response
        })
    },

    storeNewProgressFormC (id) {
        return axios({
            url: apiDomain + `api/form-c/new-progress/` + id,
            method: 'POST'
        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return e.response
        })
    },
}

export default CForm